export default {"src":"/_next/static/media/mondial-logo-mark-white-rgb.a3c67c71.svg","height":412,"width":564,"blurWidth":0,"blurHeight":0};